import { each } from 'lodash';

export default {
  set(variables, ref) {
    each(variables, (value, prop) => {
      ref.style.setProperty(prop, value);
    });
  },
};
